<template>
	<div>
		<breadcrumb :list="breadcrumbList"></breadcrumb>
		<el-card class="main">
			<el-form ref="searchEmp" :model="searchEmp" class="searchEmp">
				<el-row>
					<el-col :xs="24" :sm="12" :md="6" :lg="6">
						<el-form-item label-width="75px">
							<div slot="label">员工姓名</div>
							<el-select v-model="searchEmp.username" placeholder="请选择" clearable style="width:100%">
								<el-option v-for="item in ygxmList" :key="item.id" :label="item.username" :value="item.username">
								</el-option>
							</el-select>
						</el-form-item>
					</el-col>
					<el-col :xs="24" :sm="12" :md="6" :lg="6">
						<el-form-item label-width="75px">
							<div slot="label">角色</div>
							<el-select v-model="searchEmp.is_super" placeholder="请选择" clearable style="width:100%">
								<el-option v-for="item in roleList" :key="item.id" :label="item.role_name" :value="item.id"
									:disabled="Boolean(item.disabled)">
								</el-option>
							</el-select>
						</el-form-item>
					</el-col>
					<el-col :xs="24" :sm="12" :md="12" :lg="11" style="float:right">
						<el-row style="text-align:end;width:100%">
							<el-button type="success" @click="add"> 新增</el-button>
							<el-button type="info" @click="clean_btn">重置</el-button>
							<el-button type="primary" @click="search_btn">查询</el-button>
						</el-row>
					</el-col>
				</el-row>
			</el-form>

			<Total :total="total"></Total>

			<!-- 表格 -->

			<el-table :data="tableData" style="width: 100%" :header-cell-style="{ background: '#F1F2F7', color: '#606266' }"
				:cell-style="cellStyle">
				<!-- <el-table-column prop="username" label="账号" min-width="120" align="center">
				</el-table-column> -->
				<el-table-column prop="username" label="员工姓名" min-width="100" align="center">
				</el-table-column>
				<el-table-column prop="mobile" label="手机号" min-width="130" align="center">
				</el-table-column>
				<el-table-column prop="status" label="状态" min-width="80" align="center" :formatter="statusFliter">
				</el-table-column>
				<el-table-column prop="reg_time" label="创建时间" min-width="160" align="center" :formatter="formatDate">
				</el-table-column>
				<el-table-column label="操作" min-width="160" align="center" fixed="right">
					<template slot-scope="scope">
						<!-- <el-tag type="warning" @click="revise(row)" style="z-index:999">修改</el-tag> -->
						<el-button class="revise" size="mini" type="warning" plain @click="revise(scope.row)">修改</el-button>
						<el-button class="revise" size="mini" type="danger" plain @click="del(scope.row)" :disabled="isDel" >删除</el-button>
					</template>
				</el-table-column>

			</el-table>

			<!-- 分页 -->

			<div class="page">
				<el-pagination v-if="tableData.length != 0" class="fy" style="" layout="prev, pager, next" :total="total"
					:page-size="pageData.page_size" :current-page="pageData.page_no" @current-change="current_change" background>
				</el-pagination>
			</div>
		</el-card>
	</div>
</template>

<script>
import Total from '@/components/total/index.vue'
import { getAllRoles, getUserListByPid, getUserList, delUserItem } from '@/api/manage.js' //
import { formatDate } from '@/utils/index.js'
export default {
	name: "AccountManagementIndex",
	data() {
		return {
			breadcrumbList: [
				{ name: "账号管理", path: "account_management" },
			],
			searchEmp: {},
			tableData: [],
			total: 0,
			pageData: {
				// count: null, //总数
				page_no: 1,  //现在
				page_size: 10, //每页条数
				// page:25 //总页数
			},
			ygxmList: [], //员工姓名组
			roleList: [], // 角色组
			colClass: '',
			loading: true,
			isDel:false //删除按钮是否置灰 企业只剩一名员工时，删除按钮置灰
		};
	},
	created() {
		this.getZiDian()
		this.info()
	},
	methods: {
		async info() {
			const res = await getUserList({ ...this.pageData, ...this.searchEmp })
			this.total = res.total_result
			if (this.total <= 1) {
				this.isDel = true
			}
			this.pageData.page_no = res.page_no
			this.pageData.page_size = res.page_size
			this.tableData = res.items



		},
		add() {
			this.$router.push("/account_management/add_account_management")
		},
		clean_btn() { // 重置
			this.searchEmp = {}
			this.info()
		},
		search_btn() {//查询
			this.pageData.page_no = 1
			this.info()
		},
		cellClick({ id }) { //点击单元格,跳转详情
			this.$router.push({
				path: '/account_management/account_management_details',
				query: { id }
			})
		},
		current_change(val) { //分页功能
			this.pageData.page_no = val
			this.info()
		},
		revise({ id }) { //修改
			console.log("id", id)
			this.$router.push({
				path: '/account_management/add_account_management',
				query: { id }
			})
		},
		del({ mobile }) {//删除
			this.$confirm('此操作将永久删除该用户, 是否继续?', '提示', {
				confirmButtonText: '确定',
				cancelButtonText: '取消',
				type: 'warning'
			}).then(async () => {
				this.loading = true
				await delUserItem(mobile)
				this.$message({
					type: 'success',
					message: '删除成功!'
				})
				this.info()
			}).catch(() => {
				this.$message({
					type: 'info',
					message: '已取消删除'
				})
			})
		},
		async getZiDian() { //获取字典
			this.ygxmList = await getUserListByPid()
			this.roleList = await getAllRoles()
		},
		statusFliter(row, column, cellValue) {//过滤状态
			if (!cellValue) return
			if (cellValue == 10) {
				this.colClass = 'kaiqi'
				return "启动"
			} else if (cellValue == 20) {
				this.colClass = 'jinyong'
				return "禁用"
			}
		},
		formatDate(row, col, val) {//过滤时间
			if (!val && val != 0) return
			return formatDate(val)
		},
		cellStyle({ row, columnIndex }) { //改状态颜色
			// 状态列字体颜色
			if (row.status == '10' && columnIndex === 2) {
				return 'color: #28CD76'
			} else if (row.status == '20' && columnIndex === 2) {
				return 'color: #6B6C78'
			}
		},

	},
	beforeRouteLeave(to, from, next) {
		//离开页面如果去的详情 || 修改 则缓存当前页面
		if (to.path === '/account_management/account_management_details' ||
			to.path === '/account_management/add_account_management') {
			this.$store.commit('setKeep', 'AccountManagementIndex')
			next()
		} else {
			this.$store.commit('setKeep', '')
			next()
		}
		next()
	},
	components: { Total }
}
</script>

<style lang="less" scoped>
.revise {
	border-radius: 16px;
}

.jinyong {
	color: #6B6C78;
}

.kaiqi {
	color: #28CD76;
}
</style>